function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.66394 2.96364C5.5003 3.01819 4.36846 4.87276 1.98208 5.8955C1.36843 6.23641 1.0957 6.85005 1.23208 8.75916C1.33895 10.2554 2.93664 10.7365 3.20937 10.7365C3.42755 10.7365 13.2549 10.6455 18.1413 10.6001C18.5732 10.6228 19.2186 10.2455 19.4368 9.91826C19.8459 9.30462 19.9141 8.55461 19.7777 7.73642C19.6686 7.08187 18.7323 6.30459 18.2777 6.16823C16.3004 5.82731 15.8913 5.8955 15.414 5.4864C14.8284 4.98438 12.4293 3.05269 12.0731 2.96364C11.5276 2.82729 5.86849 2.89546 5.66394 2.96364ZM5.66394 2.96364C5.11848 2.6 3.90482 1.80455 3.41391 1.53182C2.80027 1.19091 2.18662 0.304532 1.0957 0.986357",
  stroke: "#373D49",
  strokeWidth: 0.681825,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.36889 4.1228L6.1416 6.1001H9.20982",
  stroke: "#373D49",
  strokeWidth: 0.681825,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 10.6416,
  y: 7.1228,
  width: 1.90911,
  height: 0.409095,
  rx: 0.204548,
  fill: "#373D49"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.84581,
  cy: 10.3273,
  r: 1.84093,
  fill: "#373D49"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.7999,
  cy: 10.3273,
  r: 1.84093,
  fill: "#373D49"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.84527,
  cy: 10.3275,
  r: 1.29547,
  fill: "#E9EDC4"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.8004,
  cy: 10.3275,
  r: 1.29547,
  fill: "#E9EDC4"
});

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.4f860634.svg";
export { ForwardRef as ReactComponent };